import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-enotas-nfe-generate-result-dialog',
  templateUrl: './enotas-nfe-generate-result-dialog.component.html',
  styleUrls: ['./enotas-nfe-generate-result-dialog.component.scss'],
})
export class EnotasNfeGenerateResultDialogComponent implements OnInit {
  payload: Record<string, unknown>;
  rawJsonFallback: string;
  steps: Array<Record<string, unknown>> = [];
  invoices: Array<Record<string, unknown>> = [];
  summary: unknown;
  error: Record<string, unknown> | null = null;
  metaKeys = ['startedAt', 'finishedAt', 'marinaId', 'userId', 'processControlId', 'invoiceIdsRequested'];

  constructor(public config: DynamicDialogConfig) {}

  ngOnInit(): void {
    const data = this.config.data;
    if (data && typeof data === 'object' && !Array.isArray(data)) {
      this.payload = data as Record<string, unknown>;
      this.steps = Array.isArray(this.payload['steps'])
        ? (this.payload['steps'] as Array<Record<string, unknown>>)
        : [];
      this.invoices = Array.isArray(this.payload['invoices'])
        ? (this.payload['invoices'] as Array<Record<string, unknown>>)
        : [];
      this.summary = this.payload['summary'];
      const err = this.payload['error'];
      this.error = err && typeof err === 'object' ? (err as Record<string, unknown>) : null;
      this.rawJsonFallback = '';
    } else {
      this.payload = {};
      this.rawJsonFallback = JSON.stringify(data, null, 2);
    }
  }

  asJson(value: unknown): string {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }
}
